<template>
  <div>
    <div class="mask">
      <div class="popupMessage">
        <div class="popupMessage-play">
          <div class="top">
            <span class="details">{{copyright.tl}}</span>
            <span class="close" @click="close">X</span>
          </div>
          <div class="detailsContent">
            <span class="detailsContentText" v-html="copyright.de">{{copyright.de}}</span>
          </div>
        </div>
      </div>
   </div>
  </div>
</template>

<script>
  export default {
    name: "baseTextPopup",
    props: {
      copyright: {
      }
    },
    methods:{
      close(){
        this.$emit('close')
      }
    },
    data(){
      return {}
    }
  }
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,.10);
    top: 0;
    left: 0;
  }
  .popupMessage{
    width: 100%;
    height: 600px;
  }
  .popupMessage-play{
    width: 800px;
    height: 600px;
    margin: 50px auto 0 auto;
    border-radius: 20px;
    border: 1px solid #e92540;
    background-color: #fff;
  }
  .top{
    width: 800px;
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #e92540;
  }
  .details{
    font-size: 25px;
    float: left;
    margin-left: 20px;
  }
  .close{
    font-size: 30px;
    float: right;
    margin-right: 20px;
    cursor: pointer;
  }
  .detailsContent{
    width: 780px;
    height: 525px;
    margin: 0 10px;
    text-indent: 2em;
    overflow-x: auto;
  }
  .detailsContentText{
    font-size: 18px;
    word-break: break-all;
    padding-top: 5px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/baseTextPopup/baseTextPopup.vue